import {Injectable} from '@angular/core';
import {AbstractWidgetService} from '../../services/abstract-widget.service';
import {DocumentEditorActionsType, DocumentInfo, TemplateActionArgs, UiWidget} from '@pt/pt-models';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {GetChapterResponse} from 'it/primatoo/openapi/api/org/schemas/common/docs/GetChapterResponse';
import {ChapterSelector} from "it/primatoo/openapi/api/org/schemas/common/docs/ChapterSelector";

@Injectable({
  providedIn: 'root'
})
export class WidgetAppAssessmentService extends AbstractWidgetService {

  constructor(public store: Store, public translateService: TranslateService) {
    super(store, translateService);
  }

  /**
   * TRIGGER
   * @param context
   * @param widgets
   * @param widgetId
   * @param action
   * @param args
   * @param queryResponse
   */
  execTrigger(context: GetChapterResponse, widgets: UiWidget[], widgetId: number, action: DocumentEditorActionsType, args: TemplateActionArgs, queryResponse?: any): UiWidget | null {
    const widget = widgets?.find(w => w.internalId === widgetId);
    this.unsupportedTrigger(widget);
    return null;
  }

  /**
   * INITIALIZATION
   * @param context
   * @param widgets
   * @param widgetId
   * @param action
   * @param args
   */
  initialization(context: GetChapterResponse, widgets: UiWidget[], widgetId: number, action: DocumentEditorActionsType, args: TemplateActionArgs): UiWidget | null {
    const widget = widgets?.find(w => w.internalId === widgetId);
    this.unsupportedInitialization(widget);
    return null;
  }

}
